module.exports = __webpack_public_path__ + "static/media/sf-test-11.3e3866fe.mp3";